/**
 * Authentication Service
 * Connects to real backend API for authentication
 */
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

export const authService = {
  login: async (email, password) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/api/auth/login`, {
        email,
        password
      });

      if (response.data && response.data.access_token) {
        const token = response.data.access_token;
        const user = response.data.user;
        
        // Store auth data
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(user));
        localStorage.setItem('eternityAuth', 'true');
        localStorage.setItem('eternityUser', JSON.stringify(user));
        localStorage.setItem('eternityToken', token);
        
        return { success: true, user, token };
      }
      
      return { success: false, error: 'Invalid response from server' };
    } catch (error) {
      console.error('Login error:', error);
      return { 
        success: false, 
        error: error.response?.data?.detail || 'Authentication failed. Please try again.' 
      };
    }
  },

  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('eternityAuth');
    localStorage.removeItem('eternityUser');
    localStorage.removeItem('eternityToken');
  },

  getCurrentUser: () => {
    const userStr = localStorage.getItem('user') || localStorage.getItem('eternityUser');
    return userStr ? JSON.parse(userStr) : null;
  },

  getToken: () => {
    return localStorage.getItem('token') || localStorage.getItem('eternityToken');
  },

  isAuthenticated: () => {
    const token = authService.getToken();
    return !!token && localStorage.getItem('eternityAuth') === 'true';
  },

  hasPermission: (permission) => {
    const user = authService.getCurrentUser();
    return user?.permissions?.includes(permission) || user?.permissions?.includes('full_access') || user?.role === 'Admin';
  },
};
